import { TituloBlocoParte } from "../styles";
import { ContainerCardsPartesPrincipais } from "./styles";
import { IProposta } from "../../../../../../utility/IProposta";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CardParteProfissional from "./CardPartePrincipal/CardParteProfissional";
import CardParteSolicitante from "./CardPartePrincipal/CardParteSolicitante";
import CardParteCliente from "./CardPartePrincipal/CardParteCliente";
import { useAuth } from "../../../../../../contexts/UserContext";
import { usuarioEhSolicitante } from "../../../../../../helpers/permissoesUsuario";

interface BlocoPartesPrincipaisProps {
    demanda?: IProposta | null;
    loading?: boolean;
    isEditing?: boolean;
    isDisabled?: boolean;
    onChange?: (campo: string, valor: any) => void;
    onBlur?: (campo: string) => void;
    errors?: Record<string, string>;
    onRecarregarDemanda?: () => void;
}

export default function BlocoPartesPrincipais({demanda, loading = false, isEditing = false, isDisabled = false, onChange, onBlur, errors, onRecarregarDemanda}: BlocoPartesPrincipaisProps) {
    const { user } = useAuth();

    return (
        <div>
            {loading ? (
                <ContainerCardsPartesPrincipais>
                    <Skeleton height={150} width="100%" />
                    <Skeleton height={150} width="100%" />
                    <Skeleton height={150} width="100%" />
                </ContainerCardsPartesPrincipais>
            ) : (
                <>
                <TituloBlocoParte>Principais</TituloBlocoParte>
                <ContainerCardsPartesPrincipais>
                    {!usuarioEhSolicitante(user) && (
                        <CardParteProfissional demanda={demanda} onRecarregarDemanda={onRecarregarDemanda} />
                    )}
                    <CardParteSolicitante demanda={demanda} />
                    <CardParteCliente 
                        demanda={demanda}
                        isEditing={isEditing}
                        isDisabled={isDisabled}
                        onChange={onChange}
                        onBlur={onBlur}
                        errors={errors}
                    />
                </ContainerCardsPartesPrincipais>
                </>
            )}
        </div>
    )
}